// Meta Pixel — se carga SOLO tras consentimiento de cookies.
const PIXEL_ID = "1638312613903029";
let inited = false;

export function hasConsent() {
  try {
    return localStorage.getItem("cookie_consent") === "granted";
  } catch {
    return false;
  }
}

export function initPixel() {
  if (inited || typeof window === "undefined" || !hasConsent()) return;
  inited = true;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
}

export function pixelTrackCustom(event, params) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("trackCustom", event, params || {});
  }
}

export function pixelTrack(event, params) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", event, params || {});
  }
}
